import * as Yup from "yup";
import { forceInt } from "Utils";
import { transform as userTransform } from "./User";

export const AuditLogValidationSchema = Yup.object().shape({});

export const AuditLogObjectSchema = {
    id: null,
    user_id: null,
    created_at: null,
    message: null,
    source_name: null,
    source_id: null,
    user: {},
};

export function transform(requestData) {
    if (requestData.data) {
        return requestData.data.map((item) => transform(item));
    }

    let auditLog = Object.assign({}, AuditLogObjectSchema, {
        id: forceInt(requestData.id),
        user_id: forceInt(requestData.user_id),
        created_at: requestData.created_at,
        message: requestData.message,
        source_name: requestData.source_name,
        source_id: requestData.source_id,
    });

    if (requestData.user) {
        let user = userTransform(requestData.user);
        auditLog = Object.assign({}, auditLog, { user: user });
    }

    return auditLog;
}
